import Document16 from '@carbon/icons-react/es/document/16';
import { useBoolean } from 'ahooks';
import { Image, Typography } from 'antd';
import React, { FC } from 'react';
import styled from 'styled-components';
import { IconShell } from 'components/atoms/icon-shell';
import { RocketDocument16 } from 'components/atoms/icons';

export const Title = styled(Typography.Text)`
  width: 144px;
`;

export const DocumentTitle: FC<{
  title: string;
  iconSrc?: string;
}> = ({ title, iconSrc }) => {
  const [imageError, { setTrue }] = useBoolean(false);

  return (
    <>
      <IconShell
        icon={
          iconSrc ? (
            <>
              {imageError ? (
                <Document16 />
              ) : (
                <Image
                  onError={setTrue}
                  preview={false}
                  alt={title}
                  width={16}
                  src={iconSrc}
                />
              )}
            </>
          ) : (
            <RocketDocument16 />
          )
        }
        size="xsmall"
      />
      <Title ellipsis={{ tooltip: true }}>{title}</Title>
    </>
  );
};
